// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__3toOa","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__1zJSq"};